import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import ScenarioStatus from "../ScenarioStatus";

import strings from "../../../../locales/strings";

import styles from "./ScenarioActions.scss";

const cx = classnames.bind(styles);

const ScenarioActions = ({
  notification,
  scenarios,
  scenarioLoading,
  handleScenarioBack,
  handleScenarioAction,
}) => {
  const { SelectedScenarioId, Actions } = notification;
  const { error, success, scenario } = scenarios;

  if (error) {
    return (
      <ScenarioStatus type="error">
        <div data-name="notification-sorry-something-went-wrong">
          {strings.sorrySomethingWentWrong}
          <div className={cx("scenario-back-info")}>
            {strings.clickBackAndTryAgain}
          </div>
        </div>

        <button
          className={cx("back-to-actions", "glz-link", "glz-is-dotted")}
          onClick={handleScenarioBack}
          data-name="notification-back-to-actions"
        >
          {strings.back}
        </button>
      </ScenarioStatus>
    );
  }

  if (success || SelectedScenarioId) {
    let selected = {};

    Actions.forEach((action) => {
      if (action.ScenarioId === (success ? scenario : SelectedScenarioId)) {
        selected = action;
      }
    });

    return (
      <ScenarioStatus type="success">{selected.SelectedText}</ScenarioStatus>
    );
  }

  const isScenarioLoading = Object.values(scenarioLoading).some(
    (item) => !!item
  );

  return (
    <div>
      {Actions.map((action) => {
        const isLoading = scenarioLoading[action.ScenarioId];

        return action.RedirectUrl ? (
          <a
            className={cx(
              "scenario-external-link",
              "glz-link",
              "glz-is-primary",
              "glz-is-external",
              "glz-is-underline",
              { "glz-no-events": isScenarioLoading }
            )}
            key={action.ScenarioId}
            href={action.RedirectUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {action.Text}
          </a>
        ) : (
          <button
            key={action.ScenarioId}
            data-id={action.ScenarioId}
            className={cx(
              "scenario-action-button",
              "glz-button",
              "glz-is-primary",
              "glz-is-small",
              { "glz-is-loading": isLoading }
            )}
            data-name="scenario-action-button"
            onClick={() => handleScenarioAction(action.ScenarioId)}
          >
            {action.Text}
          </button>
        );
      })}
    </div>
  );
};

ScenarioActions.propTypes = {
  notification: PropTypes.shape({
    SelectedScenarioId: PropTypes.string,
    Actions: PropTypes.arrayOf(PropTypes.object),
  }),
  scenarios: PropTypes.shape({
    error: PropTypes.bool,
    success: PropTypes.bool,
    scenario: PropTypes.string,
  }),
  scenarioLoading: PropTypes.object,
  handleScenarioBack: PropTypes.func,
  handleScenarioAction: PropTypes.func,
};

export default ScenarioActions;
